export const benefitsAccordionTableContent = [
  {
    title: 'Breakdown Cover',
    description: 'Your manufacturer warranty covers you for breakdowns for 12 months only.',
  },
  {
    title: 'Immediate Accidental Damage Cover',
    description:
      "Snaps? Breaks? Accidents happen. When they do, you're not protected by your manufacturer's warranty. We'll cover them - and more.",
  },
  {
    title: 'Immediate Accessory Coverage',
    description:
      'Broken refrigerator shelves? Wobbly stove knobs? Accessories that came with your original appliance are covered too.',
  },
  {
    title: 'Unlimited Repairs with No Hidden Costs',
    description:
      "If you need a repair, just get in touch. It's fast and hassle-free, with no deductibles or unexpected charges.",
  },
  {
    title: "Brand New Replacement if it can't be fixed",
    description: "If we can't repair your product, we'll replace it with a new one.",
  },
];
